import React, { Component } from 'react';
import { Redirect, Link, history } from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from './../../Header';
import CustomerTabMenu from './CustomerTabMenu';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import $ from 'jquery';
class MuviFreeList extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            customers: [],
            apiUrl: this.decryptconfigdata('apiUrl'),
            studioUrl: this.decryptconfigdata('studioUrl'),
            activePage: 1,
            item_count: '',
            from_date: '',
            to_date: '',
            search: '',
            studio_id: '',
            user_id: '',
            purchase_url: '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            isLoadMore: 1,
            Loading: 1,
            startDate: '',
        };
        this.onChange = this.onChange.bind(this);
        this.getCustomers = this.getCustomers.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.formdateChange = this.formdateChange.bind(this);
        this.todateChange = this.todateChange.bind(this);
        this.keywordChange = this.keywordChange.bind(this);
        this.customer_details = this.customer_details.bind(this);
        this.movetoDemo = this.movetoDemo.bind(this);
        this.handleChangeStart = this.handleChangeStart.bind(this);
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    onChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }
    goToCustomerStore(email, password, studio_id, studio_name) {
        if (window.confirm("Are you sure to login this store '" + studio_name + "' ?")) {
            var win = window.open(this.state.studioUrl + "/login/storeLogin" + "?email=" + email + "&password=" + password + "&studio_id=" + studio_id, '_blank');
            win.focus()
        }
    }
    formdateChange(event) {
        this.setState({ from_date: event.target.value }, function () {
            this.getCustomers();
        });
    }

    handleChangeStart(date) {
        this.setState({
            startDate: date,
            start_date: moment(date).format("YYYY-MM-DD")
        });
    }

    todateChange(event) {
        this.setState({ to_date: event.target.value }, function () {
            this.getCustomers();
        });
    }
    keywordChange(event) {
        var obj = this;
        this.setState({
            search: event.target.value,
            activePage: 1,
            customers: []
        });
        //Delaying the function execute
        if (this.timer) {
            window.clearTimeout(this.timer);
    }
        this.timer = window.setTimeout(function () {
            //Execute the function code here...
            obj.getCustomers();
        }, 500);
    }
    customer_details(studio_id, studio_name, user_id) {
        document.getElementById('new_password').value = ''
        this.setState({ message1: '' })
        fetch(this.state.apiUrl + '/AdminRest/customerdetails/studio_id/' + studio_id + '/user_id/' + user_id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                this.setState({
                    studio_id: findresponse.studio_id,
                    user_id: findresponse.user_id,

                })

                if (this.state.studio_id.start_date != '0000-00-00') {
                    let x = Date.parse(this.state.studio_id.start_date);
                    this.setState({ startDate: moment(x) })
                }

            })
    }
    movetoDemo(studio_id, studio_name, user_id) {
        if (window.confirm("Are you sure you want to move '" + studio_name + "' account to demo studio?")) {
            fetch(this.state.apiUrl + '/adminRest/movetoDemo/id/' + studio_id + '/userAuthKey/' + this.state.userAuthKey, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    if (findresponse.code == 200) {
                        this.setState({ message: findresponse.msg })
                    } else {
                        this.setState({ message: findresponse.msg })
                    }
                    this.getCustomers();
                    this.setState({
                    })
                })
        }
    }
    ExtendTrialPeriod(studio_id) {
        if (window.confirm("Are you sure you want to extend trial period?")) {
            fetch(this.state.apiUrl + '/AdminRest/ExtendTrialPeriod/studio_id/' + studio_id + '/start_date/' + this.state.start_date + '/userAuthKey/' + this.state.userAuthKey, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    if (findresponse.code == 200) {
                        this.setState({ message1: findresponse.msg }, function () {
                            window.location.href = '/muvifreeStores';
                        });
                    } else {

                        this.setState({ message1: findresponse.msg })
                    }
                })
        }
    }
    CancelAccount(studio_id, user_id) {
        fetch(this.state.apiUrl + '/AdminRest/CancelAccount/studio_id/' + studio_id + '/user_id/' + user_id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message1: findresponse.msg }, function () {
                        window.location.href = '/muvifreeStores';
                    });
                } else {

                    this.setState({ message1: findresponse.msg })
                }
            })
    }
    loadMore(pageNumber) {
        this.setState({ isLoadMore: 0 })
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });
        fetch(this.state.apiUrl + '/adminRest/GetMuviFree/page/' + pageNumber + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.customers.length == 0) {
                    this.setState({
                        isLoadMore: 2
                    })
                } else {
                    this.setState({
                        isLoadMore: 1
                    })
                }
                this.setState({
                    //isLoadMore:1,
                    customers: this.state.customers.concat(findresponse.customers),
                    //item_count: findresponse.item_count,
                })
            })
    }
    Savepassword(studio_id, user_id) {
        fetch(this.state.apiUrl + '/AdminRest/Savepassword/studio_id/' + studio_id + '/user_id/' + user_id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        window.location.href = '/muvifreeStores';
                    });
                } else {

                    this.setState({ message: findresponse.msg })
                }
            })
    }
    export() {
        var win = window.open(this.state.apiUrl + "/AdminRest/ExportUsers/userAuthKey/" + this.state.userAuthKey + "/user_type/muvifree/search/" + this.state.search, '_self');
        win.focus()
    }
    getCustomersMenu(studio_id, studio_name, user_id, email, encrypted_password, name) {
        if (this.state.store_permission == 1) {
            return (
                <ul class="onclick-menu-content">
                    <li onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, name)}><a>Log-In to Customer Account</a></li>
                    <li onClick={() => this.customer_details(studio_id, studio_name, user_id)} data-toggle="modal" data-target="#changePassword"><a>Change Password</a></li>
                    <li onClick={() => this.movetoDemo(studio_id, studio_name, user_id)}><a>Move to Demo</a></li>
                    <li onClick={() => this.customer_details(studio_id, studio_name, user_id)} data-toggle="modal" data-target="#cancelAccount"><a>Cancel Account</a></li>
                    <li onClick={() => this.customer_details(studio_id, studio_name, user_id)} data-toggle="modal" data-target="#extendfreetrial"><a>Extend Free Trial</a></li>
                </ul>
            )
        }

        else {
            return (
                <ul class="onclick-menu-content">
                    <li onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, name)}><a>Log-In to Customer Account</a></li>
                </ul>
            )
        }

    }
    handlePageChange(pageNumber = 1) {
        var totalPages = Math.ceil(this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
            this.setState({ activePage: pageNumber, setPage: 'no' });
            fetch(this.state.apiUrl + '/adminRest/GetMuviFree/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                    this.setState({
                        customers: findresponse.customers,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    })
                })
        }
    }
    getCustomers(page = 1) {
        fetch(this.state.apiUrl + '/adminRest/GetMuviFree/page/' + page + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                this.setState({
                    customers: findresponse.customers,
                    item_count: findresponse.item_count,
                    store_permission: findresponse.store_permission,
                    purchase_url: findresponse.purchase_url,
                    Loading: 0,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes'
                })
            })

    }
    componentDidMount() {
        this.getCustomers(1, 1);
        document.title = "Intranet | Muvi Free";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
    }
    loadMorecount() {
        if (this.state.item_count > 0) {
            if (this.state.item_count >= 20) {
                if (this.state.isLoadMore != 2) {
                    if (this.state.isLoadMore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="load_more" onClick={() => this.loadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    }
                    else {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple"><div></div><div></div></div>
                            </div>
                        )
                    }
                }
            }
        }
        else {
            return (
                <div className="text-center">No Data Found</div>
            )
        }
    }
    getMuviFreeList() {
        if (this.state.Loading) {
            return (
                <div>
                    <div class="loader-new"></div>
                </div>
            )
        } else {
            return (
                <section class="customer">
                    <div id="exTab1" class="container">
                        <CustomerTabMenu brecum_page="muvifreelist" />
                        <div class="tab-content clearfix">
                            <div class="tab-pane active" id="Leads">
                                <div class="row">
                                    <div class="col-md-6 col-xs-12">
                                        <button id="export" class="btn btn-blue" onClick={() => this.export()}>Export To CSV</button>
                                    </div>
                                    <div class="col-md-6 col-xs-12 pull-right">
                                        <div class="searchTicket mob_customer">
                                            <input type="text" class="form-control" name="customer" id="customer" placeholder="Search company, name or email" onChange={this.keywordChange} /><button type="submit"><i class="fa fa-search"></i></button>
                                        </div>
                                    </div>
                                </div>
                                <div class="list_check">
                                    <div class="tickets hidden-sm">
                                        <ul class="tickets_head">
                                            <li class="intra_col_15">Company</li>
                                            <li class="intra_col_20">Name</li>
                                            <li class="intra_col_15">Website</li>
                                            <li class="intra_col_10">Country</li>
                                            <li class="intra_col_5">Logins</li>
                                            <li class="intra_col_10">Joined On</li>
                                            <li class="intra_col_20">Source</li>
                                            <li class="intra_col_5"></li>
                                        </ul>
                                        {
                                            this.state.customers.map((data, key) =>
                                                <ul class="tickets_number">
                                                    <li class="intra_col_15"><Link key={key} to={`/ViewDetail/${data.studio_id}`} name={"max"}> {data.name}</Link></li>
                                                    <li class="intra_col_20">{data.first_name}</li>
                                                    <li class="intra_col_15 text-inded"><a href={'http://' + data.domain} target="_blank">{data.domain}</a></li>
                                                    <li class="intra_col_10">{data.country}</li>
                                                    <li class="intra_col_5">{data.logins}</li>
                                                    <li class="intra_col_10">{data.created_at_change}</li>
                                                    <li class="intra_col_20">
                                                        <div class="text-inded">{data.source}
                                                            <a href={this.state.purchase_url + 'signup/purchasesubscription.html?studio=' + data.uniqid}>{this.state.purchase_url + 'signup/purchasesubscription.html?studio=' + data.uniqid}</a>
                                                        </div>
                                                    </li>
                                                    <li class="intra_col_5 customer_details">
                                                        <div tabindex="0" class="onclick-menu c-details pull-right">
                                                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                                            {this.getCustomersMenu(data.studio_id, data.first_name, data.user_id, data.email, data.encrypted_password, data.name)}
                                                        </div>
                                                    </li>
                                                </ul>

                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="customer_mob hidden-md">
                            {
                                this.state.customers.map((data, key) =>
                                    <div class="custmer_list_mob">
                                        <Link key={key} to={`/ViewDetail/${data.studio_id}`} name={"max"}>
                                            <h4 class="list_title">{data.first_name}</h4>
                                        </Link>
                                        <Link key={key} to={`/ViewDetail/${data.studio_id}`} name={"max"}>
                                            <div class="wrap">{data.domain}</div>
                                        </Link>
                                        <div tabindex="0" class="onclick-menu pull-right">
                                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                            {this.getCustomersMenu(data.studio_id, data.first_name, data.user_id, data.email, data.encrypted_password, data.name)}
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        {this.state.item_count > 0 ? <div class="pagination-muvi">
                            <Pagination
                                itemClass={'pages'}
                                itemClassFirst={'first_page'}
                                itemClassPrev={'prev_page'}
                                itemClassNext={'next_page'}
                                itemClassLast={'last_page'}
                                activePage={this.state.activePage}
                                itemsCountPerPage={20}
                                totalItemsCount={this.state.item_count}
                                pageRangeDisplayed={5}
                                onChange={this.state.setPage == 'yes' ? this.handlePageChange : ''}
                            />
                            <div style={{ color: "#333" }}>
                                {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                            </div>
                        </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}
                        {/* {this.loadMorecount()} */}
                    </div>
                </section>
            )
        }
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div >
                <div class="modal fade" id="extendfreetrial" role="dialog">
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                                <h4 style={{ color: "black" }} class="modal-title">Extend Free Trial</h4>
                            </div>
                            <div class="modal-body">
                                <label><b>Company</b></label>
                                <input type="text" name="company" value={this.state.studio_id.name} className="form-control" readOnly />

                                <label><b>Date</b></label>

                                <DatePicker
                                    selected={this.state.startDate}
                                    selectsStart
                                    startDate={this.state.startDate}
                                    onChange={this.handleChangeStart}
                                    minDate={moment()}
                                    dateFormat="DD/MM/YYYY"
                                    readOnly={true}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                />

                                <span style={{ color: "red" }}>{this.state.message1}</span>
                                <br />

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-blue" data-dismiss="modal">Cancel</button>
                                <button type="button" class="btn btn-sky" onClick={() => this.ExtendTrialPeriod(this.state.studio_id.id, this.state.user_id.id)}>Submit</button>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="cancelAccount" role="dialog">
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                                <h4 style={{ color: "black" }} class="modal-title">Cancel Account</h4>
                            </div>
                            <div class="modal-body">
                                <label><b>Company</b></label>
                                <input type="text" name="company" value={this.state.studio_id.name} className="form-control" onChange={this.onChange} readOnly />

                                <input type="hidden" value={this.state.studio_id.id} name="studio_id" onChange={this.onChange} />
                                <input type="hidden" value={this.state.user_id.id} name="user_id" onChange={this.onChange} />
                                <br />
                                <label><b>Reason</b></label>
                                <textarea style={{ resize: "none" }} class="form-control" name="custom_notes" id="custom_notes" required onChange={this.onChange}></textarea>
                                <span style={{ color: "red" }}>{this.state.message1}</span>
                                <br />

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                                <button type="button" class="btn btn-default" onClick={() => this.CancelAccount(this.state.studio_id.id, this.state.user_id.id)}>Submit</button>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="changePassword" role="dialog">
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                                <h4 style={{ color: "black" }} class="modal-title">Update Password</h4>
                            </div>
                            <div class="modal-body">
                                <label><b>New Password</b></label>
                                <input type="text" name="new_password" id="new_password" className="form-control" onChange={this.onChange} />
                                <span style={{ color: "red" }}>{this.state.message}</span>
                                <input type="hidden" value={this.state.studio_id.id} name="studio_id" />
                                <input type="hidden" value={this.state.user_id.id} name="user_id" />
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                                <button type="button" class="btn btn-default" onClick={() => this.Savepassword(this.state.studio_id.id, this.state.user_id.id)}>Update</button>

                            </div>
                        </div>
                    </div>
                </div>
                <Header brecum_name="Customer" brecum_page="Muvi Free" />
                <div className="right_col">
                    {this.getMuviFreeList()}
                </div>
            </div>
        );
    }
}


export default MuviFreeList;


// WEBPACK FOOTER //
// ./src/components/customer/MuviFreeList.js